export const filteredExtensions: readonly string[] = [
  "application/ics",
  "image/jpeg",
  "image/png",
  "text/calendar",
] as const;

export const isFilteredAttachmentMimeType = (mimeType: string) => {
  const normalizedMimeType = mimeType.split(";")[0]?.toLowerCase().trim() || mimeType;

  return filteredExtensions.includes(normalizedMimeType);
};
